import React, { useState, useEffect } from 'react';
import api from '../services/api';

const LibraryPage = () => {
  const [resources, setResources] = useState([]);
  useEffect(() => {
    api.get('/library').then(res => setResources(res.data));
  }, []);
  return (
    <div className="p-6">
      <h2 className="text-2xl mb-4">Library Resources</h2>
      <ul className="list-disc pl-5">
        {resources.map(r => (
          <li key={r.id}>{r.title}</li>
        ))}
      </ul>
    </div>
  );
};

export default LibraryPage;
